var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9188 13.273H16.6008V19.409H24.7158C23.4158 23.5 20.2158 24.864 16.5358 24.864C15.11 24.8659 13.7048 24.5238 12.4395 23.8668C11.1741 23.2098 10.0859 22.2573 9.26721 21.09C8.44849 19.9228 7.92342 18.5752 7.73655 17.1618C7.54968 15.7483 7.70652 14.3107 8.19377 12.9707C8.68102 11.6308 9.48429 10.4282 10.5354 9.46497C11.5866 8.50171 12.8546 7.80622 14.2318 7.43752C15.6091 7.06882 17.055 7.03778 18.4468 7.34704C19.8386 7.6563 21.1352 8.29673 22.2268 9.21399L26.6858 4.967C24.8901 3.31308 22.718 2.12242 20.3579 1.49837C17.9977 0.874323 15.521 0.835743 13.1425 1.38598C10.7641 1.93622 8.55594 3.05865 6.70968 4.65583C4.86343 6.25302 3.4349 8.27668 2.5481 10.5512C1.66131 12.8256 1.34305 15.2822 1.62095 17.7076C1.89885 20.1329 2.76452 22.4538 4.1428 24.4688C5.52109 26.4837 7.37033 28.1318 9.53001 29.27C11.6897 30.4081 14.0945 31.002 16.5358 31C24.8068 31 32.2828 25.545 30.9188 13.273Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.cc52fe96173adcc229901c9a618301c2.svg";
export { ForwardRef as ReactComponent };